import React from 'react'
import Stars from './Stars'
import Clocks from './Clocks'

export default function TimeManagement ({data}) {
  

  return (
    <div className="skill-box time-management">
      <div className="skill-information">
        <h1 className="skill-name">Time Management</h1>
        <Stars stars={data.stars} />
        <p className="skill-description">
          This rating shows the likelihood that your students were able to make their best guess and skip overly difficult questions
          while managing to correctly answer relatively easy questions toward the back of the test. The graphic shows the time
          management rating for each subject.
        </p>
      </div>
      <Clocks clocks={data.clocks} />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTaking/TimeManagement.js